import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <nav className="main-nav">
        <div className="container">
          <Link to="/" className="logo">
            <img src="/images/fulllogo_transparent_nobuffer.webp" alt="QuantumSync Logo" onError={(e) => {
              e.target.src = '/images/fulllogo_transparent.webp';
            }} />
          </Link>
          
          <ul className="nav-menu">
            <li><Link to="/signup" className="btn-nav btn-signup">Sign up</Link></li>
            <li><Link to="/login" className="btn-nav btn-login">Login</Link></li>
          </ul>
          
          <button className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
